import { gql } from '@apollo/client'

export const HIGH_VALUE_BASKET_SUMMARY_QUERY = gql`
  query HighValueBasketSummary($month: ISO8601Date, $minGrandTotal: Int) {
    highValueBasketSummary(month: $month, minGrandTotal: $minGrandTotal) {
      month
      minGrandTotal
      staleAfterDays
      cashIn {
        received { value }
        awaitingReceipt { value }
        transferredBack { value }
        net { value }
        onlineReceived { value }
        todayReceived { value }
        todayAwaitingReceipt { value }
      }
      totals {
        totalCount
        openCount
        wonCount
        lostCount
        needsFollowUpCount
        winRate
        total { value }
        open { value }
        won { value }
      }
      assignees {
        assignee {
          id
          fullName
        }
        totalCount
        openCount
        wonCount
        lostCount
        needsFollowUpCount
        winRate
        total { value }
        open { value }
        won { value }
      }
    }
  }
`

export const HIGH_VALUE_BASKET_LEADS_QUERY = gql`
  query HighValueBasketLeads(
    $month: ISO8601Date
    $minGrandTotal: Int
    $status: String
    $assigneeId: String
    $first: Int
    $after: String
  ) {
    highValueBasketLeads(
      month: $month
      minGrandTotal: $minGrandTotal
      status: $status
      assigneeId: $assigneeId
      first: $first
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        orderNumber
        customerName
        grandTotal { value }
        state
        stateLabel
        status
        assignDate
        lastActivityAt
        needsFollowUp
        quotationViewedAt
        customerNotesCount
        assignee {
          id
          fullName
        }
      }
    }
  }
`

export const HIGH_VALUE_BASKET_ONLINE_PAYMENTS_QUERY = gql`
  query HighValueBasketOnlinePayments($month: ISO8601Date, $first: Int, $after: String) {
    highValueBasketOnlinePayments(month: $month, first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        transferDate
        amount { value }
        receiptVoucher
        orderNumber
        sales {
          id
          fullName
        }
        cses {
          id
          fullName
        }
      }
    }
  }
`
